export default "__VITE_ASSET__DcVkEhV0__"